import { render, staticRenderFns } from "./Convogli.vue?vue&type=template&id=5a95bf17&scoped=true"
import script from "./Convogli.vue?vue&type=script&lang=js"
export * from "./Convogli.vue?vue&type=script&lang=js"
import style0 from "./Convogli.vue?vue&type=style&index=0&id=5a95bf17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a95bf17",
  null
  
)

export default component.exports